define('enums/outbound/ImportStates',[], function () {
    'use strict';
    return {
        IN_PROGRESS: 'IN_PROGRESS',
        FAILED: 'FAILED'
    };
});
